module.exports = __webpack_public_path__ + "static/media/color-sharp4.ab4ea9eb.jpg";